import { fromJS } from 'immutable';
import { STATUS } from 'src/constants/Status';
import { actionsTypes } from './constants';

const initialState = fromJS({
  status: null,
  data: '',
  layout: {
    status: STATUS.LOADING,
    data: {},
  },
});

const offeringReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionsTypes.FETCH_PAGE.PENDING:
      return state.set('status', STATUS.LOADING);
    case actionsTypes.FETCH_PAGE.SUCCESS:
      return state.set('status', STATUS.SUCCESS).set('data', payload.data);
    case actionsTypes.FETCH_PAGE.ERROR:
      return state.set('status', STATUS.ERROR);

    case actionsTypes.FETCH_LAYOUT.PENDING:
      return state.setIn(['layout', 'status'], STATUS.LOADING);
    case actionsTypes.FETCH_LAYOUT.SUCCESS:
      return state
        .setIn(['layout', 'status'], STATUS.SUCCESS)
        .setIn(['layout', 'data'], payload.data);
    case actionsTypes.FETCH_LAYOUT.ERROR:
      return state.setIn(['layout', 'status'], STATUS.ERROR);

    case actionsTypes.CLEAR_VALUES:
      return initialState;

    default:
      return state;
  }
};
export default offeringReducer;
